const NotFoundPage = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-light text-center">
      <h1 className="display-1 fw-bold text-danger">404</h1>
      <p className="fs-3">
        🚫 <span className="text-danger">Page not found</span>
      </p>
    </div>
  );
};
export default NotFoundPage;
